"use client";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { Table as a, Paragraph as i, TextLink as b } from "@ingeniorforeningen/figurine-core";
import { forwardRef as h } from "react";
import '../../../../assets/TablesTicket.css';const T = "_tableData_1g2h9_2", k = "_description_1g2h9_10", x = "_text_1g2h9_21", g = "_link_1g2h9_28", f = "_price_1g2h9_32", t = {
  tableData: T,
  description: k,
  text: x,
  link: g,
  price: f
}, o = h((d, _) => {
  const { items: m } = d;
  return /* @__PURE__ */ e("div", { ref: _, children: /* @__PURE__ */ e(a, { children: /* @__PURE__ */ e(a.Tbody, { children: m.map(({ description: c, amount: r, text: s, link: l }, p) => /* @__PURE__ */ n(a.Tr, { children: [
    /* @__PURE__ */ n("td", { "aria-label": c, children: [
      /* @__PURE__ */ e(i, { text: c, className: t.description }),
      s && /* @__PURE__ */ e(i, { text: s, variant: "success", className: t.text }),
      l && /* @__PURE__ */ e(b, { ...l, className: t.link })
    ] }),
    /* @__PURE__ */ e("td", { "aria-label": r, className: t.tableData, children: /* @__PURE__ */ e(
      i,
      {
        text: `${r} kr.`,
        align: "right",
        variant: "primary",
        className: t.price
      }
    ) })
  ] }, `tabelTicketItem${p}`)) }) }) });
});
o.displayName = "TableTicket";
const u = o;
export {
  o as _TableTicket,
  u as default
};
